<template>
  <div class="delivery-form-item" :class="[['delivery_content_id'].includes(formKey) ? 'inline-block' : 'w-full']">
    <!-- 渠道号 -->
    <div v-if="formKey === 'fusion__channel_code_prefix'" class="w-full flex items-center">
      <el-input v-model="formItem.value" v-bind="formItem.props" />
      <el-button :loading="add_channel_config.loading" type="primary" @click="onAddChannel">添加渠道</el-button>
    </div>
    <!-- 已添加的渠道 -->
    <div v-if="formKey === 'fusion__channel_codes'">
      <div v-show="show_channel_preview">
        <el-card :body-style="{ padding: 0 }" shadow="never">
          <div class="font-16 font-weight text-right channel-preview-header">
            渠道数：{{ formItem.value[formItem.tabIndex].list.length }}
          </div>
          <div class="w-full tag-scrollbar-wrapper">
            <channel-preview :form-item="formItem" />
          </div>
        </el-card>
      </div>
    </div>
    <!-- 投放内容 -->
    <div v-if="formKey === 'delivery_content_id'">
      <!-- 单一广告主分配 -->
      <div v-if="formItem.is_single_advertiser_assign">
        <el-button v-if="!formItem.isPreview" type="primary" @click="formItem.is_open = true">选择投放内容</el-button>
        <div v-if="Object.keys(formItem.value.result_map || {}).length">
          <div v-for="(item, key) in formItem.value.result_map" :key="key">
            <span class="mr-20">{{ key }}</span>
            <span class="mr-20">{{ getOptionByValue(formItem.value.type_selection, item.type).label || '-' }}</span>
            <span>{{ getOptionByValue(item.options, item.value).label || '-' }}</span>
          </div>
        </div>
        <div v-if="!Object.keys(formItem.value.result_map || {}).length && formItem.isPreview">-</div>
        <el-dialog
          title="投放内容配置"
          :visible.sync="formItem.is_open"
          :close-on-click-modal="false"
          :append-to-body="true"
          :modal-append-to-body="true"
          width="800px"
        >
          <delivery-content v-if="formItem.is_open" ref="delivery-content-ref" :form-item="formItem" :init-ops="initOps" :data-map="getDataMap()" />
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="confirm(formItem)">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 首个广告主 -->
      <div v-if="!formItem.is_single_advertiser_assign && !formItem.isPreview" class="flex items-center">
        <div v-show="show_delivery_content">
          <el-input v-model.trim="delivery_content_config.form_model.app_id" class="mr-10" clearable style="width: 300px;" placeholder="请输入应用ID或小游戏ID" :validate-event="false" />
          <el-button type="success" size="mini" :loading="delivery_content_config.loading" @click="onAddDeliveryContent">{{ delivery_content_config.loading ? '提交新建中...' : '提交新建' }}</el-button>
          <el-button type="info" size="mini" @click="onHiddenField">取消</el-button>
        </div>
        <div v-show="!show_delivery_content" class="ml-10">
          <el-button type="primary" size="mini" :loading="delivery_content_config.loading" @click="onPullDeliveryContent">{{ delivery_content_config.loading ? '同步中...' : '同步' }}</el-button>
          <el-button type="primary" size="mini" @click="onShowField">新建应用</el-button>
          <el-tooltip content="若未找到应用信息，可点击新建应用并在左侧输入框填入应用ID或小游戏ID后，点击提交新建" placement="top-start">
            <i class="el-icon-question font-16 ml-10" />
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- 星广联投任务配置 -->
    <div v-if="formKey === 'star_tasks'">
      <div>
        <div class="flex items-center">
          <el-button v-if="!formItem.isPreview" type="primary" @click="() => openAssignStarTask(formItem)">选择任务</el-button>
          <div v-if="!Object.keys(formItem.value || {}).length && formItem.isPreview">-</div>
          <div v-if="Object.keys(formItem.value || {}).length && formItem.isPreview">
            <div v-for="(item, key) in formItem.value" :key="key">
              <div v-for="task in item" :key="task.id">
                <span class="mr-20">{{ key }}</span>
                <span class="mr-20">{{ task.id || '-' }}</span>
                <span>{{ task.name || '-' }}</span>
              </div>
            </div>
          </div>
          <i v-if="Object.keys(formItem.value || {}).length && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
        </div>
        <el-dialog
          title="星广联投任务配置"
          :visible.sync="formItem.is_open"
          :close-on-click-modal="false"
          :append-to-body="true"
          :modal-append-to-body="true"
          width="800px"
        >
          <star-tasks :key="Date.now()" :form-item="formItem" />
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="() => confirmAssignStarTask(formItem)">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div></template>
<script>
import { unique, getArrayIntersection, getArrayDifference } from '@/utils';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { useGetChannelDetails } from '@/views/fusion/investment/intelligence-create/hooks';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { pullDeliveryContentApi, addDeliveryContentApi } from '@/api/tool/delivery-content';

export default {
  components: {
    'channel-preview': () => import('./components/channel-preview/index.vue'),
    'delivery-content': () => import('./components/delivery-content/index.vue'),
    'star-tasks': () => import('./components/star-tasks/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  data() {
    return {
      add_channel_config: {
        loading: false,
      },
      delivery_content_config: {
        loading: false,
        form_model: {
          app_id: '',
        },
      },
    };
  },
  computed: {
    /** 是否显示投放内容操作区域 */
    show_delivery_content() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id } = delivery_form.config;
      return delivery_content_id.props.style.display === 'none';
    },
    /** 是否显示添加的渠道列表 */
    show_channel_preview() {
      const { delivery_form } = this.formFields.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      const ret = fusion__channel_codes.value.reduce((pre, cur) => pre.concat(cur.list), []);
      return !!ret.length;
    },
  },
  methods: {
    /**
     * 添加渠道
     * @returns {void}
     */
    onAddChannel() {
      this.add_channel_config.loading = true;
      const { delivery_form } = this.formFields.config;
      const { fusion__channel_code } = delivery_form.config;
      const {
        fusion__channel_code_begin_num,
        fusion__channel_code_count,
        fusion__channel_code_prefix,
        fusion__channel_codes,
      } = fusion__channel_code.children;
      const channel_start = fusion__channel_code_begin_num.value;
      const channel_count = fusion__channel_code_count.value;
      const channel_prefix = fusion__channel_code_prefix.value;
      const channels = [];
      for (let i = channel_start; i <= channel_start + (channel_count - 1); i++) {
        const channel = `${channel_prefix}${i}`;
        channels.push(channel);
      }
      if (channel_prefix.trim() === '') {
        this.$message.warning(fusion__channel_code_prefix.rules.message);
        this.add_channel_config.loading = false;
        return;
      }
      const ret_handler = (data) => data.map(({ alias }) => alias);
      const ret = fusion__channel_codes.value.reduce((pre, cur) => pre.concat(cur.list), []);
      const intersection_list = getArrayIntersection(ret_handler(ret), channels);

      const is_repeat = intersection_list.length > 0;

      if (is_repeat) {
        this.$message.error(`添加失败，${intersection_list.join('、')}重复，不允许重复相同的渠道号`);
        this.add_channel_config.loading = false;
        return;
      }
      useGetChannelDetails(channels).then((res) => {
        const difference_list = getArrayDifference(channels, ret_handler(res));
        const is_diff = difference_list.length > 0;
        if (is_diff) {
          this.$message.error(`添加失败，${difference_list.join('、')}不存在，请检查后重试`);
          return;
        }
        const { tabIndex } = fusion__channel_codes;
        const channels_ret = unique(fusion__channel_codes.value[tabIndex].list.concat(res), 'alias');
        const form_context = this.local_sharing_data.getFormContext();
        const { channel_config } = form_context.config;
        const { campaign: campaign_restriction } = channel_config;
        const { max_campaign_num } = campaign_restriction;
        if (channels_ret.length > max_campaign_num) {
          this.$message.warning(`每个广告主账户最多能添加${max_campaign_num}个渠道`);
        }
        fusion__channel_codes.value[tabIndex].list = channels_ret.splice(0, max_campaign_num);
      }).finally(() => {
        this.$nextTick(() => {
          this.$parent.$parent.$parent.$parent.$parent.validateField('fusion__channel_code.children.fusion__channel_codes.value');
        });
        this.add_channel_config.loading = false;
        /** 滚动条回到顶部 */
        const channel_dom = document.querySelectorAll('.tag-scrollbar-wrapper .el-scrollbar__wrap');
        channel_dom[channel_dom.length - 1].scroll({ behavior: 'smooth', top: 0 });
      });
    },
    /**
     * 设置投放内容下拉框数据
     * @returns {Promise<void>}
     */
    async setDeliveryContent() {
      const { delivery_form } = this.formFields.config;
      const { delivery_platform_type, delivery_content_id } = delivery_form.config;
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const delivery_content_list = await dataController.getDeliveryContent({ delivery_platform_type: delivery_platform_type.value });
      delivery_content_id.options.splice(0);
      delivery_content_id.options.push(...delivery_content_list);
    },
    /**
     * 同步投放内容
     * @returns {Promise<void>}
     */
    async onPullDeliveryContent() {
      try {
        this.delivery_content_config.loading = true;
        const { delivery_form } = this.formFields.config;
        const { delivery_platform_type } = delivery_form.config;
        const form_context = this.local_sharing_data.getFormContext();
        const { init_ops } = form_context.config;
        const { channel_interface, advertiser_ids } = init_ops;
        const params = {
          channel_interface,
          advertiser_ids,
          delivery_platform_type: delivery_platform_type.value,
        };
        const { message = '同步成功！' } = await pullDeliveryContentApi(params);
        await this.setDeliveryContent();
        this.$message.success(message);
      } finally {
        this.delivery_content_config.loading = false;
      }
    },
    /**
     * 创建投放内容接口
     * @returns {Promise<void>}
     */
    async onAddDeliveryContent() {
      try {
        const app_id = this.delivery_content_config.form_model.app_id;
        if (app_id.trim() === '') {
          this.$message.warning('请输入应用ID或小游戏ID');
          return;
        }
        this.delivery_content_config.loading = true;
        const { delivery_form } = this.formFields.config;
        const { delivery_platform_type } = delivery_form.config;
        const form_context = this.local_sharing_data.getFormContext();
        const { dataController } = form_context.config;
        const channel_interface = dataController.getChannelInterfaceEnum();
        const advertiser_id = dataController.getRequestAdvertiser();
        const payload = {
          channel_interface,
          advertiser_id,
          delivery_platform_type: delivery_platform_type.value,
          app_id,
        };
        await addDeliveryContentApi(payload);
        await this.setDeliveryContent();
        this.onHiddenField();
        this.$message.success('新建成功！');
      } finally {
        this.delivery_content_config.loading = false;
      }
    },
    /**
     * 显示新建应用输入框
     * @returns {void}
     */
    onShowField() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id } = delivery_form.config;
      delivery_content_id.props.style.display = 'none';
      this.delivery_content_config.form_model.app_id = '';
      this.$parent.clearValidate(['delivery_content_id.value']);
    },
    /**
     * 隐藏新建应用输入框
     * @returns {void}
     */
    onHiddenField() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id } = delivery_form.config;
      delivery_content_id.props.style.display = 'inline-block';
    },
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     * @returns {Object}
     */
    getOptionByValue(options, val) {
      return options.find(({ value }) => value === val) || {};
    },
    /**
     * 获取数据表
     * @returns {Object}
     */
    getDataMap() {
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const {
        delivery_form: {
          config: {
            delivery_platform_type,
          },
        },
      } = this.formFields.config;

      const getDeliveryContentList = (advertiser_id, delivery_platform_type) => dataController.getDeliveryContentById(advertiser_id, { delivery_platform_type });

      return delivery_platform_type.options.reduce((acc, cur) => Object.assign(acc, { [cur.value]: getDeliveryContentList }), {});
    },
    /**
     * 投放内容配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirm(form_item) {
      const result = this.$refs['delivery-content-ref']?.table_data || [];
      const is_valid = result.every(({ type, target }) => type?.value && target?.[type.value]?.value);
      if (is_valid) {
        result.forEach(({ advertiser_id, type, target }) => {
          Object.assign(form_item.value.result_map, { [advertiser_id]: {
            type: type.value,
            options: target[type.value].options,
            value: target[type.value].value,
          }});
        });
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField('delivery_content_id.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 打开星广联投任务配置
     * @param form_item 表单项
     * @returns {void}
     */
    openAssignStarTask(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 星广联投任务配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmAssignStarTask(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const { config: { init_ops: { advertiser_ids }}} = this.local_sharing_data.getFormContext();
      const is_valid = advertiser_ids.every(advertiser_id => result[advertiser_id]?.length);
      if (is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField('star_tasks.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
  },
};
</script>

<style lang="scss">
.tag-scrollbar-wrapper {
  .el-scrollbar {
    .el-scrollbar__wrap {
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}

.channel-preview-header {
  padding: 8px 20px;
  border-bottom: 1px solid #DCDFE6;
}

.app-check-icon-success {
  color: #67C23A;
  font-size: 24px;
}
</style>
